import axios from "axios";
import { useState } from "react";
import Swal from "sweetalert2";
import { ASINRETAILEROPTIONS, metaCategories } from "../../constants";

const FLIPKARTPRODUCTURLREGEX = /^(https:\/\/|)www.flipkart.com\/(\w|-)+\/p\/\w+/
const AmazonAsinIds = ({ crossSell, gender, isDataLoading, updateVideoData, videoId }) => {

  const [showIdInput, setShowIdInput] = useState(false)
  const [showURLInput, setShowURLInput] = useState(false)
  const [category, setCategory] = useState(null)
  const [crossSellToUpdate, setCrossSellToUpdate] = useState([])

  const updateCrossSell = async () => {
    const response = await axios.post(`/images-meta-api/videos/video/crossSell?id=${videoId}`, { crossSell: crossSellToUpdate })
    updateVideoData()
    setCrossSellToUpdate([])

  }

  const updateAsinCategoryValuesToUpdate = (newId, toDelete = false, retailer, retailerUrl) => {

    setCrossSellToUpdate(prev => {
      const newValuesToUpdate = [...prev];
      if (!newValuesToUpdate.filter(c => c.category == category).length > 0) {
        newValuesToUpdate.push({ category, products: [] })
      }
      const categoryAsin = newValuesToUpdate.filter(c => c.category == category)[0]
      if (categoryAsin.products.filter(v => v.asinId == newId).length > 0) {
        Swal.fire({ icon: "warning", html: `item <span className="font-bold">${newId}</span> is already present` })
        return newValuesToUpdate
      }
      const link =
        retailer == ASINRETAILEROPTIONS[0] ? `https://amazon.in/dp/${newId}` :
          retailer == ASINRETAILEROPTIONS[1] ? retailerUrl :
            retailer == ASINRETAILEROPTIONS[2] ? `https://www.myntra.com/${newId}` : undefined
      categoryAsin.products.push({ asin: newId, productUrl: link, delete: toDelete, retailer })
      return newValuesToUpdate
    })
  }

  function changeCategory(e) {
    setCategory(e.target.id)
  }

  const handleRetailerChange = () => {
    const retailer = document.querySelector('#asin-retailer-name').value
    if (retailer == "") {
      setShowIdInput(false)
      setShowURLInput(false)
    } else if (retailer == ASINRETAILEROPTIONS[1]) {
      setShowIdInput(false)
      setShowURLInput(true)
    } else {
      setShowIdInput(true)
      setShowURLInput(false)
    }
  }


  const handleNewId = () => {
    console.log("ckhab")
    const retailer = document.querySelector('#asin-retailer-name').value
    if (retailer == "" || !retailer) {
      Swal.fire({ text: "Please Select a retailer" })
      return
    }
    let newId = "";
    let retailerUrl = "";
    if (retailer == ASINRETAILEROPTIONS[1]) {
      retailerUrl = document.querySelector('#asin-retailer-product-url').value
      newId = retailerUrl.split('?')[0].split('/p/').pop()
    } else {
      newId = document.querySelector('#amazon-asin-new-id-input').value
    }
    retailerUrl = retailerUrl.split('?')[0];
    if (newId == '') {
      Swal.fire({ icon: "warning", text: "No ID Provided" })
      return
    }
    if (retailer == '') {
      Swal.fire({ icon: "warning", text: "No Retailer Provided" })
      return
    }
    if (retailer == ASINRETAILEROPTIONS[1] && !retailerUrl.match(FLIPKARTPRODUCTURLREGEX)) {
      Swal.fire({ icon: "warning", text: "Flipkart url does not match https://www.flipkart.com/<product-pug>/p/<product-code>?<optional> format" })
      return
    }
    updateAsinCategoryValuesToUpdate(newId, false, retailer, retailerUrl)

    document.querySelector('#asin-retailer-name').value = ""
    if (retailer && retailer != ASINRETAILEROPTIONS[1]) {
      document.querySelector('#amazon-asin-new-id-input').value = ""
    }
    if (retailer && retailer == ASINRETAILEROPTIONS[1]) {
      document.querySelector('#asin-retailer-product-url').value = ""
    }
    setShowURLInput(false)
    setShowIdInput(false)

  }

  const deleteAsinOnButtonClick = (e) => {
    const deleteAsin = e.target.id

    updateAsinCategoryValuesToUpdate(deleteAsin, true)
  }

  const updateImageButtonClick = (e) => {
    const buttonId = e.target.id
    e.target.disabled = true
    const asin = buttonId.split('-').pop()
    const inputImage = document.querySelector(`#update-image-input-${asin}`).value

    axios.post(`/images-meta-api/update-product-image-url/${asin}`, { imageUrl: inputImage }).then(response => {
      if (response.data.success) {
        Swal.fire({ text: "Image URL Updated", icon: "success" })

        document.querySelector(`#update-image-input-${asin}`).value = ""
        e.target.disabled = false
      }
    })

  }


  return <>

    <div className="flex m-2 p-2 border-t w-full flex-wrap">
      <select value={category}
        onChange={(e) => {
          setCategory(e.target.value)
        }}
        className='p-2 px-4 rounded-full border mx-1'>
        <option value='' >--select subcategory--</option>
        {metaCategories.sort().map(cat => < option value={cat} >{cat}</option>)}
      </select>
      {
        crossSell.map(c => <button
          key={c.category}
          id={c.category}
          onClick={changeCategory}
          className="primary-btn mx-2"
        >   {c.category}</button>)
      }
    </div>
    {category ?
      <table className="border-collapse min-w-full table-auto mt-4 border border-slate-600 mb-10 pb-10 overflow-x-auto">
        <thead>
          <tr>
            <th className="border border-slate-600 min-w-28">ASIN</th>
            <th className="border border-slate-600 min-w-28">Retailer</th>
            <th className="border border-slate-600 min-w-28">Link</th>
            <th className="border border-slate-600 min-w-28">Product Image</th>
            <th className="border border-slate-600 min-w-28">DELETE</th>
          </tr>

        </thead>
        <tbody className="mb-10 pb-10">

          {
            crossSell && crossSell.filter(cat => cat.category == category).length > 0 && crossSell.filter(c => c.category == category)[0].products ?
              crossSell.filter(cat => cat.category == category)[0].products.map(tdata => <tr key={tdata.asin} className='border-b w-full even:bg-slate-100'>
                <td className="text-center border">{tdata.asin}</td>
                <td className="text-center border">{tdata.retailer}</td>
                <td className="text-center border">{tdata.productUrl}</td>
                <td className="p-2 border">
                  {
                    tdata.imageUrl ? <div>
                      <img src={tdata.imageUrl} className="h-40 mx-auto" />
                      <p className="w-60 text-wrap text-center mx-auto">{tdata.imageUrl}</p>
                    </div> : null
                  }
                  <div className="">
                    <div>
                      <input
                        className="w-full border rounded p-1 text-center outline-none focus:border-slate-500 "
                        id={`update-image-input-${tdata.asin}`}
                      />
                    </div>
                    <div>
                      <button
                        className="primary-btn my-1 mx-auto"
                        id={`update-image-button-${tdata.asin}`}
                        onClick={updateImageButtonClick}
                      >Update Image URL</button>
                    </div>
                  </div>
                </td>
                <td className="flex justify-center py-1 border">
                  <button
                    className="bg-red-600 p-2 rounded hover:bg-red-700 disabled:bg-red-400 text-white"
                    onClick={deleteAsinOnButtonClick}
                    id={tdata.asin}
                    disabled={crossSellToUpdate && crossSellToUpdate.filter(c => c.category == category)[0] && crossSellToUpdate.filter(c => c.category)[0].products.filter(v => v.delete).map(v => v.asin).includes(tdata.asin)}
                  >DELETE</button>
                </td>
              </tr >)
              : null
          }
          {
            crossSellToUpdate && crossSellToUpdate.filter(cat => cat.category == category).length > 0 && crossSellToUpdate.filter(cat => cat.category == category)[0].products ?
              crossSellToUpdate.filter(cat => cat.category == category)[0].products.filter(tdata => !tdata.delete).map(tdata => <tr key={tdata.asin} className='border-b w-full bg-blue-200 odd:bg-blue-100'>
                <td className="text-center border">{tdata.asin}</td>
                <td className="text-center border">{tdata.retailer}</td>
                <td className="text-center border">{tdata.productUrl}</td>
                <td className="flex justify-center py-1 border">
                </td>
              </tr >)
              : null
          }
          <tr className="w-full p-2">
            <td className="p-2 border">
              <select id="asin-retailer-name" className="w-full bg-slate-50 border rounded outline-none p-2" defaultValue={""}
                onChange={handleRetailerChange}
              >
                <option disabled value="">--select--</option>

                {ASINRETAILEROPTIONS.map(retailer => <option value={retailer}>{retailer}</option>)}
              </select>
            </td>
            <td className="p-2 border" colSpan={3}>
              {showIdInput ? <input type={'text'} id="amazon-asin-new-id-input" className="w-full bg-slate-50 border rounded outline-none p-2" placeholder="Enter Product ID" /> : null}
              {showURLInput ? <input type={'text'} id="asin-retailer-product-url" className="w-full bg-slate-50 border rounded outline-none p-2" placeholder="Product URL for flipkart" /> : null}
            </td>
            <td className="p-2 border"><button className="p-2 rounded bg-blue-600 hover:bg-blue-700 text-white w-full" onClick={handleNewId}>Add ASIN</button></td>
          </tr>
          <tr className="w-full p-2 border pt-8">
            <td className="p-2 border pt-20" colSpan={5}><button className="px-2 py-1 bg-slate-700 active:bg-slate-900 disabled:bg-slate-400 rounded hover:bg-slate-800 text-white w-full disabled:italic" disabled={isDataLoading} onClick={updateCrossSell}>Update Data</button></td>
          </tr>
        </tbody >
      </table >
      : null}
  </>
}

export default AmazonAsinIds;
